import { searchALP, UOALP } from '@redturtle/iosanita-alp/reducers';
import searchALPIcon from '@redturtle/iosanita-alp/icons/search-alp.svg';
import { SearchALPEdit, SearchALPView } from '@redturtle/iosanita-alp/components/Blocks';
import PersonaLiberaProfessione from '@redturtle/iosanita-alp/components/View/Persona/PersonaLiberaProfessione';
export TableLP from '@redturtle/iosanita-alp/components/TableLP/TableLP';

const applyConfig = (config) => {
  config.addonReducers = {
    ...config.addonReducers,
    searchALP,
    UOALP,
  };

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    searchALP: {
      id: 'searchALP',
      title: 'Ricerca Att. Libera Profess.',
      icon: searchALPIcon,
      group: 'search',
      view: SearchALPView,
      edit: SearchALPEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 0,
    },
  };

  const defualtViewConfig = config.views.ioSanitaContentTypesViewsConfig ?? {};
  config.views.ioSanitaContentTypesViewsConfig = {
    ...defualtViewConfig,
    Persona: {
      ...(defualtViewConfig.Persona ?? {}),
      pushSections: [...(defualtViewConfig.Persona?.pushSections ?? []), { /* LIBERA PROFESSIONE */ component: PersonaLiberaProfessione, atIndex: 6, key: 'LP' }],
    },
  };

  return config;
};

export default applyConfig;
